import clsx from "clsx";
import React, { useEffect, useState } from "react";
import DefaultImageCard from "../images/defaultImageCard.png";
import { useParams } from "react-router-dom";

function SiteCard(props) {
  const { lang } = useParams();
  const [detailSite, setDetailSite] = useState(null);
  const focusSiteId = props.focusSite?.Id;

  useEffect(() => {
    setDetailSite(props.detailSite);
  }, [props.detailSite]);

  function onClickCard(param) {
    if (props.disable) return;

    try {
      props.onClick(detailSite);
    } catch {}
  }

  const getNameCard = detailSite?.Name.includes('"name_english"')
    ? JSON.parse(detailSite?.Name)
    : detailSite?.Name;

  const nameCard =
    typeof getNameCard === "string"
      ? getNameCard
      : lang === "th"
      ? getNameCard?.name_thai
      : getNameCard?.name_english;

  return (
    <div
      className={`relative w-24 h-24 mr-2 overflow-hidden rounded-lg shadow-xl cursor-pointer hover:scale-105 transition-all duration-300 ${clsx(
        {
          "ring-2 ring-vekin-primary-light ring-offset-1 scale-105":
            focusSiteId === detailSite?.Id,
        }
      )}`}
      onClick={(e) => {
        onClickCard(e);
      }}
    >
      {/* !detailSite?.Image.includes("data:") */}
      {detailSite?.Image && detailSite?.ImageId !== 0 ? (
        <img
          className="absolute w-full h-full bg-vekin-primary object-cover"
          src={detailSite?.Image}
          alt=""
        />
      ) : (
        <img
          className="absolute w-full h-full bg-vekin-primary object-cover"
          src={DefaultImageCard}
          alt="default-image-card"
        />
      )}
      <div
        className="absolute bottom-0 flex w-full h-1/2 bg-gradient-to-t from-vekin-primary/90 to-vekin-primary/0"
        style={{
          overflowWrap: "anywhere",
        }}
      >
        <span
          className="h-full p-2 text-xs leading-none text-white text-semibold"
          title={nameCard}
        >
          {nameCard}
        </span>
      </div>
    </div>
  );
}

export default SiteCard;
